export default "__VITE_PUBLIC_ASSET__e57b8629__"